import Spinner from 'reactstrap/es/Spinner';
import { RenderFuncField } from '@yooink/yocontextforms/es/RenderFuncField';
import InputGroup from 'reactstrap/es/InputGroup';
import InputGroupAddon from 'reactstrap/es/InputGroupAddon';
import { FaCopy } from 'react-icons/fa';
import Button from 'reactstrap/es/Button';
import Input from 'reactstrap/es/Input';
import { copyToClipboard } from '@yooink/youtils/es/copyToClipboard';
import { toast } from 'react-toastify';
import Col from 'reactstrap/es/Col';
import Row from 'reactstrap/es/Row';
import { SimpleDragRowField } from '@yooink/yocontextforms/es/SimpleDragRowField';
import ListGroupItem from 'reactstrap/es/ListGroupItem';
import ListGroup from 'reactstrap/es/ListGroup';
import { LabelField } from '@yooink/yocontextforms/es/LabelField';
import { EditorProvider } from '@yooink/yocontextforms/es/SimpleEditorContext';
import { useEditorContextSiteSettings } from './SiteSettings/useSiteSettings';
import { Block } from '@yooink/youi/dist/Layout/Block';
import { Header } from '@yooink/youi/dist/Layout/Header';

export function TelegramBotSettings () {
	const [settingsController, save, isLoading] = useEditorContextSiteSettings('dashboard.telegramBot.');
	if (isLoading) return <Spinner />;

	return (
		<EditorProvider controler={settingsController}>
			<Block>
				<Header title="Интеграция telegram бота с группами" />
				<Row>
					<Col>
						<h4>Settings</h4>
						<RenderFuncField field="joinToken">
							{(token) => {
								const joinToken = `group_JT_${token}`;
								return (
									<InputGroup>
										<Input value={joinToken} onClick={(e) => e.target.select()} disabled />
										<InputGroupAddon addonType="append">
											<Button onClick={() => {
												copyToClipboard(joinToken);
												toast.info('copped');
											}}
											>
												<FaCopy />
											</Button>
										</InputGroupAddon>
									</InputGroup>
								);
							}}
						</RenderFuncField>
					</Col>
					<Col>
						<h4>Connected chats</h4>
						<SimpleDragRowField field="chats" postListItem={() => null} ItemClass={ListGroupItem} ListClass={ListGroup}>
							<LabelField>Chat Info</LabelField>
							<RenderFuncField field="">
								{(info) => (
									<ul>
										<li>
											id: {info.id}
										</li>
										<li>
											name: {info.title}
										</li>
										<li>
											added: {new Date(info.createdAt).toLocaleString()}
										</li>
									</ul>
								)}
							</RenderFuncField>
						</SimpleDragRowField>
					</Col>
				</Row>
			</Block>
			<Button onClick={() => save()}>save</Button>
		</EditorProvider>
	);
}
